
import { ProjectScrapReasonModel, ScrapReasonModel, StationModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { scrapReasonsStore } from '@/libs/scrap-reasons/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';

@Component({})
export default class ProjectScrapReasonList extends Page {
    projectScrapReasons: ProjectScrapReasonModel[] = [];
    @Prop() workplaceId!: string;
    @Prop() inputValue!: ProjectScrapReasonModel[];

    mounted() {
        if (this.inputValue) {
            this.projectScrapReasons = this.inputValue;
        }
    }

    get items(): StationModel[] {
        let items: ScrapReasonModel[] = scrapReasonsStore.useGetter(CrudGetter.Data) ?? [];
        return items.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    }

    isSelected(scrapReasonId: string): boolean {
        return this.projectScrapReasons?.some((x) => x.scrapReasonId == scrapReasonId);
    }

    onSelectChange(scrapReasonId: string) {
        const items = [...(this.projectScrapReasons ?? [])];
        if (this.isSelected(scrapReasonId)) {
            items.splice(items.indexOf(items.find((x) => x.scrapReasonId == scrapReasonId)!), 1);
        } else {
            items.push({
                scrapReasonId: scrapReasonId,
            });
        }
        this.projectScrapReasons = items;
        this.$emit('change', items);
    }
}
